export default __webpack_public_path__ + "static/media/clear.1b10619e.png";